import {BaseContainerModel} from '../../base-container.model';
import {
  bl_fi_mst_item_ext_RowClass,
  bl_fi_mst_item_hdr_RowClass,
  bl_fi_mst_item_line_RowClass,
  bl_fi_mst_label_hdr_RowClass,
  bl_fi_mst_label_link_RowClass
} from '../../../dbschema';
import {ExtQueryCriteria} from '../../ExtQueryCriteria';

export class FinancialItemWithLabelContainerModel extends BaseContainerModel {
  bl_fi_mst_item_hdr: bl_fi_mst_item_hdr_RowClass = new bl_fi_mst_item_hdr_RowClass();
  bl_fi_mst_item_lines: bl_fi_mst_item_line_RowClass[] = [];
  bl_fi_mst_item_exts: bl_fi_mst_item_ext_RowClass[] = [];
  bl_fi_mst_label_links: bl_fi_mst_label_link_RowClass[] = [];
  bl_fi_mst_label_hdrs: bl_fi_mst_label_hdr_RowClass[] = [];
}

export class FinancialItemWithLabelQueryCriteria {
  offset: number;
  limit: number;
  orderBy: string;
  order: string;

  keyword: string;
  txn_type: string;
  txn_class: string;
  code: string;
  name: string;
  descr: string;
  status: string;
  exts: ExtQueryCriteria[] = [];
  links: LabelLinkQueryCriteria[] = [];
}


export class LabelLinkQueryCriteria {
  guid_label_hdr: string;
  header_table: string;
}
